import { Link } from "react-router-dom";
import HeartbeatLine from "@/components/HeartbeatLine";

export default function NotFound() {
    return (
        <section className="min-h-[80vh] flex items-center bg-white">
            <div className="container-7m text-center max-w-2xl">
                <div className="font-heading font-black text-[140px] lg:text-[220px] tracking-tighter leading-none text-brand">404</div>
                <HeartbeatLine height={40} />
                <h1 className="mt-8 font-heading font-black text-3xl lg:text-4xl tracking-tighter">Pagina non trovata.</h1>
                <p className="mt-4 text-ink-muted">La pagina che cercavi non esiste o è stata spostata.</p>
                <Link to="/" className="btn-primary mt-10" data-testid="notfound-cta">Torna alla home</Link>
            </div>
        </section>
    );
}
